<template>
  <div id='box'>
      <footer class="footer">
    <div class="footer-inner container">
      <div class="footer-top">
          <div class="footer-top-title">成为技术突出的世界级工程服务企业</div>

        <img src="/imgs/home/images/footer-logo_03.png" alt="" />

      </div>
      <div class="footer-bottom">
          <dl class="footer-list">
            <div class="footer-col">
              <router-link to="/goin"><dt>走进企业</dt></router-link>
              <dd><router-link to="/goin">企业介绍</router-link></dd>
              <dd><router-link to="/goin">发展历程</router-link></dd>
              <dd><router-link to="/goin">企业文化</router-link></dd>
              <dd><router-link to="/goin">荣誉资质</router-link></dd>
              <dd><router-link to="/goin">员工风采</router-link></dd>
            </div>
            <div class="footer-col">
              <router-link to="/product"><dt>匠心产品</dt></router-link>
              <!-- <dd><router-link to="/goin">俄罗斯</router-link></dd>
              <dd><router-link to="/goin">中亚</router-link></dd>
              <dd><router-link to="/goin">北美</router-link></dd>
              <dd><router-link to="/goin">南美</router-link></dd>
              <dd><router-link to="/goin">中东</router-link></dd> -->
            </div>
            <div class="footer-col">
              <router-link to="/tech"><dt>科技研发</dt></router-link>
              <dd><router-link to="/tech">现场案例</router-link></dd>
            </div>
            <div class="footer-col">
              <router-link to="/goin"><dt>应用领域</dt></router-link>
              <!-- <dd><router-link to="/goin">俄罗斯</router-link></dd>
              <dd><router-link to="/goin">中亚</router-link></dd>
              <dd><router-link to="/goin">北美</router-link></dd> -->
            </div>
            <div class="footer-col">
              <router-link to="/news"><dt>新闻动态</dt></router-link>
              <dd><router-link to="/news">新闻中心</router-link></dd>
            </div>
            <div class="footer-col">
              <router-link to="/contact"><dt>联系我们</dt></router-link>
              <dd><router-link to="/contact">联系信息</router-link></dd>
              <dd><router-link to="/contact">在线留言</router-link></dd>
            </div>
            <div class="footer-col footer-phone">
              <img src="/imgs/home/images/footer-dianhua_03.png" alt="">
              <span>400 0000 1010</span>
            </div>
          </dl>
          <hr style="width: 100%; margin: 40px auto;">

      </div>

    </div>
  </footer>
      
  </div>
</template>

<script>
export default {
  components: {
      
  },
  data () {
      return {
          
      }
  },
  created() {
      
  },
  mounted() {
      
  },
  methods: {
      
  },
}
</script>

<style scoped>
.footer {
min-height: 420px;
background-image: url(/public/imgs/home/images/footer-bg_02.png);
background-size: cover;
background-position: center;

font-size: 1.3rem;
color: #000000;
font-family: "HarmonyOS_Sans_SC_Light";

position: relative;
}

/* 底部整体布局 */
.footer-inner {
max-width: 1600px;
width: 100%;
margin: 0 auto;
padding: 80px 20px 40px;
}

/* 顶部区域 */
.footer-top {
width: 95%;
display: flex;
justify-content: space-between;
align-items: center;
margin-bottom: 40px;
}
.footer-top-title {
font-size: 3.5rem;
margin-bottom: 20px;
/* font-weight:550; */
color: #ff8a00;
letter-spacing: 0.1em;
}

/* 底部四列 */
.footer-bottom {
display: flex;
justify-content: space-between;
flex-wrap: wrap;
}
.footer-list {
width: 100%;
display: flex;
align-items: flex-start;

margin: 0;
}
.footer-col {
/* flex: 1; */
min-width: 135px;
margin-bottom: 20px;
}
.footer-col dt {
font-weight: bold;
margin-bottom: 16px;
color: #000;
}
.footer-col dd {
margin: 0 0 8px 0;
line-height: 1.6;
}
.footer-col dd a {
  font-size: 1.1rem;
color: #454545;
text-decoration: none;
}
.footer-phone {
display: flex;
align-items: center;
margin-left: auto;
}
.footer-phone img {
margin-right: 10px;
}
.footer-phone span {
font-size: 1.8rem;
font-weight: 600;
/* color:#e60013; */
}
.footer-right {
  width: 100%;
display: flex;
justify-content: flex-end;
align-items: center;
}
.footer-right img {
margin: 0 10px;
}

/* 移动端隐藏 footer */
@media (max-width: 768px) {
.footer {
  display: none;
}
}

</style>